export const advice_zh = {
    'lateralhead':{
        name:'头侧倾',
        risk:'头侧倾，改变颈椎排列，往往伴随高低肩，儿童养成偏头的坏习惯，或加重颈椎、脊柱侧弯等，也可能影响视力',
        advice:{
            score30:{
                content:'应避免思考或学习时习惯把头长时间靠在一侧的姿势'
            },
            score60:{
                content:'建议去进一步影像学检查或进一步关节活动度及功能评估，并配合针对性的调整训练'
            }
        }
    },
    'unevenshoulder':{
        name:'高低肩',
        risk:'高低肩不但影响美观引起了脊柱的变形，脊柱侧弯严重会压迫脊柱周边神经造成内脏积压，影响呼吸和睡眠',
        advice:{
            score30:{
                content:'避免用单侧提/拉重物比如背单肩包，均匀地使用身体两侧发力，避免坐姿歪斜'
            },
            score60:{
                content:'建议去进一步影像学检查或进一步关节活动度及功能评估，并配合针对性的调整训练'
            }
        }
    },
    'unevenhip':{
        name:'骨盆侧倾',
        risk:'骨盆侧倾严重时会伴随下肢不等长和脊柱侧弯、高低肩、斜颈，还可能导致骨盆的整体功能下降，双侧膝关节压力也失衡',
        advice:{
            score30:{
                content:'避免跷二郎腿的动作、坐姿的纠正与保持、改善站立/走路时重心总在一只脚上'
            },
            score60:{
                content:'建议去进一步影像学检查或进一步关节活动度及功能评估，并配合针对性的调整训练'
            }
        }
    },
    'xleg':{
        name:'X型腿',
        risk:'X型腿，可影响外形美观，若轻微，则可在儿童生长过程中减轻或改善。严重时X型腿影响双下肢长度力线',
        advice:{
            score30:{
                content:'孩子应避免W坐，可以选择性做些强化髋外旋外展肌群动作如臀桥等，或配合下肢生物力学鞋垫'
            },
            score60:{
                content:'建议去进一步影像学检查或进一步关节活动度及功能评估，并配合针对性的调整训练'
            }
        }
    },
    'oleg':{
        name:'O型腿',
        risk:'O型腿又称罗圈腿，影响美观，严重时会影响下肢骨骼排列身高发育',
        advice:{
            score30:{
                content:'防止过度股骨内旋造成的O 型腿，预防高足够弓，调整下肢力线的排列'
            },
            score60:{
                content:'建议去进一步影像学检查或进一步关节活动度及功能评估，并配合针对性的调整训练'
            }
        }
    },
    'xoleg':{
        name:'XO型腿',
        risk:'XO型腿可能八岁内八字，行走时容易绊倒，重心可能偏移，多伴随下肢有扭转',
        advice:{
            score30:{
                content:'应注意观察孩子的腿型变化，建议做针对性腿型矫正训练防止胫骨扭转的进一步加重'
            },
            score60:{
                content:'建议去进一步影像学检查或进一步关节活动度及功能评估，并配合针对性的调整训练'
            }
        }
    },
    'scoliosis':{
        name:'脊柱异位',
        risk:'容易引发高低肩、影响身高发育，严重时会挤压内脏',
        advice:{
            score30:{
                content:'应避免歪斜坐姿，翘二郎腿等不对称站姿坐姿，可多做一些核心稳定性训练如四足爬行等。有针对性的脊柱矫正训练'
            },
            score60:{
                content:'建议去进一步影像学检查或进一步关节活动度及功能评估，并配合针对性的调整训练'
            }
        }
    },
    'forwardhead':{
        name:'头前倾',
        risk:'头前倾，或使颈椎产生变形，容易压缩颈动脉和减少血液流向脑部，引起到达大脑的氧气和脑营养物减少。孩子往往没有精神，亦或伴随含胸驼背，亦可影响身高',
        advice:{
            score30:{
                content:'日常注意走路时抬头挺胸、避免长时间低头动作等；亦可做些仰头训练，拉伸胸锁乳突肌等促进颈椎正确排列'
            },
            score60:{
                content:'建议去进一步影像学检查或进一步关节活动度及功能评估，并配合针对性的调整训练'
            }
        }
    },
    'roundedshoulder':{
        name:'圆肩',
        risk:'圆肩往往伴随驼背，会影响呼吸模式。长期可能会严重到背部畸形，整个脊柱向后拱起，形成驼背，影响个人气质',
        advice:{
            score30:{
                content:'应注意避免长时间弓背坐和低头站等异常坐姿和站姿，可做一些扩胸运动缓解'
            },
            score60:{
                content:'建议去进一步影像学检查或进一步关节活动度及功能评估，并配合针对性的调整训练'
            }
        }
    },
    'kneehyperextension':{
        name:'膝过伸',
        risk:'膝超伸容易造成，懒汉站姿，不然影响身高而且影响人的气质，严重会伴随膝关节损伤、腰部两失衡、含胸驼背',
        advice:{
            score30:{
                content:'应注意纠正站姿防止孩子站立时过度往后伸膝盖，做一些控制性训练'
            },
            score60:{
                content:'建议去进一步影像学检查或进一步关节活动度及功能评估，并配合针对性的调整训练'
            }
        }
    }
}

export function analysisConclusion(risks){
    let conclusion = '',conclusionKey = ''
    let conclusionSet = new Set()
    risks.forEach(item =>{
        console.log(item)
        if (item.value > 60) {
            conclusionKey = 'score60'
        } else {
            conclusionKey = 'score30'
        }
        console.log(conclusionKey)
        if (advice_zh[item.key]){
            let result = advice_zh[item.key]
            conclusionSet.add(result.advice[conclusionKey].content)
        }
    })
    conclusionSet.forEach(item => {
        conclusion += item + '；\n'
    })
    return conclusion;
}

export function getRiskByMuscleKey(muscleKey){
    let result = advice_zh[muscleKey]
    if (result){
        return result.risk;
    }
    return ""
}